import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './components/login/login.component';
import { SignupComponent } from './components/signup/signup.component';
import { HttpErrorInterceptor } from './interceptor/http-error.interceptor';
import { CustomerAccountsModule } from './modules/customer-accounts/customer-accounts.module';
import { HomeModule } from './modules/home/home.module';
//
import { GlobalErrorHandlerService } from './services/global-error-handler.service';
import { NewAgentApiService } from './services/new-agent-api.service';
// import { ApiService } from './services/api.service';
import { HeaderComponent } from './components/common/header/header.component';
import { FooterComponent } from './components/common/footer/footer.component';
import { SidenavComponent } from './components/common/sidenav/sidenav.component';
import { AlertsComponent } from './components/common/alerts/alerts.component';


import { environment } from 'src/environments/environment';
import { LoggerModule } from 'ngx-logger';
import { DashboardComponent } from './components/dashboard/deshboard/dashboard.component';
import { CaseManagementCardComponent } from './components/dashboard/case-management-card/case-management-card.component';
import { LogoutPageComponent } from './components/logout-page/logout-page.component';
import { MainComponent } from './components/main/main.component';
import { UserProfileDataCardComponent } from './components/user-profile-data-card/user-profile-data-card.component';
//import { InteractionHistoryComponent } from './components/customerAccounts/interaction-history/interaction-history.component';
import { SsofailureComponent } from './components/ssofailure/ssofailure.component';
import { ALISRegistrationComponent } from './components/dashboard/alis-registration/alis-registration.component';
import { SharedModule } from './modules/shared module/shared.module';
import { SpeedTestModule } from 'ng-speed-test';
import { TbaRegistrationComponent } from './components/dashboard/tba-registration/tba-registration.component';
import { PaginationComponent } from './components/customerAccounts/pagination/pagination.component';
import { OpenMessageComponent } from './components/customerAccounts/open-message/open-message.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { DashboardFilterComponent } from './components/dashboard/dashboard-filter/dashboard-filter.component';
import { AgentInteractionHistoryComponent } from './components/dashboard/agent-interaction-history/agent-interaction-history.component';
import { AppointmentsCardComponent } from './components/dashboard/appointments-card/appointments-card.component';
import { UnknownCallerComponent } from './components/customerAccounts/unknown-caller/unknown-caller.component';
import { SimulationManagerComponent } from './components/simulation-manager/simulation-manager.component';
import { DatabaseSelectorComponent } from './components/database-selector/database-selector.component';
import { AdministrationComponent } from './components/administration/administration.component';
import { DeleteBatchAlertComponent } from './components/common/delete-batch-alert/delete-batch-alert.component';
import { ViewParticipantsComponent } from './components/common/view-participants/view-participants.component';
import { AdminFilterComponent } from './components/admin-filter/admin-filter.component';
import { CreateBatchAlertComponent } from './components/create-batch-alert/create-batch-alert.component';
import { CreateAlertProgressModalComponent } from './components/common/create-alert-progress-modal/create-alert-progress-modal.component';
import { CurrentBatchAlertComponent } from './components/current-batch-alert/current-batch-alert.component';
import { DeleteBatchTableComponent } from './components/delete-batch-table/delete-batch-table.component';
import { ArchivedBatchAlertComponent } from './components/archived-batch-alert/archived-batch-alert.component';
import { ALISSSOComponent } from './components/alis-sso/alis-sso.component';
import { PersonInternalIdComponent } from './components/customerAccounts/person-internal-id/person-internal-id.component';
import { PrivacyPolicyModalComponent } from './components/customerAccounts/privacy-policy-modal/privacy-policy-modal.component';
import { ViewNoteLogComponent } from './components/customerAccounts/view-note-log/view-note-log.component';


//import { DomainDetailsComponent } from './components/customerAccounts/domain-details/domain-details.component';

//import { TestRoutingModule } from './components/test/test-routing.module';
const environmentConfig: any = environment.logger;
@NgModule({ declarations: [
        AppComponent,
        LoginComponent,
        SignupComponent,
        HeaderComponent,
        FooterComponent,
        SidenavComponent,
        DashboardComponent,
        AlertsComponent,
        CaseManagementCardComponent,
        LogoutPageComponent,
        MainComponent,
        UserProfileDataCardComponent,
        // InteractionHistoryComponent,
        SsofailureComponent,
        ALISRegistrationComponent,
        TbaRegistrationComponent,
        PaginationComponent,
        OpenMessageComponent,
        DashboardFilterComponent,
        AgentInteractionHistoryComponent,
        AppointmentsCardComponent,
        SimulationManagerComponent,
        DatabaseSelectorComponent,
        AdministrationComponent,
        DeleteBatchAlertComponent,
        ViewParticipantsComponent,
        AdminFilterComponent,
        CreateBatchAlertComponent,
        CreateAlertProgressModalComponent,
        CurrentBatchAlertComponent,
        DeleteBatchTableComponent,
        ArchivedBatchAlertComponent,
        ALISSSOComponent, //CCR3-13543
        PersonInternalIdComponent,
        PrivacyPolicyModalComponent,
        ViewNoteLogComponent
        //UnknownCallerComponent,
        // CustomerSearchUnidentifiedCallComponent
        //DomainDetailsComponent,
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HomeModule,
        SharedModule,
        CustomerAccountsModule,
        SpeedTestModule, NgIdleKeepaliveModule.forRoot(),
        LoggerModule.forRoot({
            //serverLoggingUrl: environment.apiUrl + Global.customerApi.lambda,//where you give the full path to your api end-point for logging to server. This is optional, if you don’t need logs to be sen’t to server, delete this line.
            level: environmentConfig.level, //defines the minimum log level in the browser. Available levels are: TRACE, DEBUG, INFO, LOG, WARN, ERROR, FATAL and OFF. These values come from NgxLoggerLevel class.
            // serverLogLevel: environmentConfig.serverLogLevel,//defines the minimum log level for server-side logging.
            //disableConsoleLogging :true //disable all console log
        })], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
